export default __webpack_public_path__ + "static/media/mail_letter.6905197b.jpg";